export const cardProfile = {
  name: "Peter McGraw",
  title: "Founder and AI Architect",
  company: "Stratyx Ventures",
  location: "Tampa, FL // Orange County, CA",
  bio: "Passionate technology leader shaping tomorrow's tech landscape with SaaS, AI, dynamic innovation, & consulting strategies",
  image: "/images/pete-mcgraw.webp",
  email: "jpetermcgraw@gmail.com",
  phone: "+13155592961",
  website: "https://stratyxventures.com"
};

export const cardLinks = [
  {
    name: "Text",
    url: "sms:+13155592961",
    icon: "message-square",
    type: "action"
  },
  {
    name: "Contact Card",
    url: "#vcard",
    icon: "contact",
    type: "vcard"
  },
  {
    name: "Stratyx Discord",
    url: "https://discord.gg/E5XCSrycRB",
    icon: "discord",
    type: "link"
  },
  {
    name: "Personal Email",
    url: "mailto:jpetermcgraw@gmail.com",
    icon: "mail",
    type: "link"
  },
  {
    name: "Stratyx",
    url: "https://stratyxventures.com",
    icon: "globe",
    type: "link"
  },
  {
    name: "Chiip Email",
    url: "mailto:pete@chiip.app",
    icon: "mail",
    type: "link"
  },
  {
    name: "Chiip Deck",
    url: "https://pitch.com/public/419e0f5f-cfc4-435e-8700-04ee0f18c677",
    icon: "globe",
    type: "link"
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/peter-mcgraw",
    icon: "linkedin",
    type: "link"
  },
  {
    name: "Blue Mtn. BPO Deck",
    url: "https://pitch.com/v/blue-mtn-dnxnga",
    icon: "globe",
    type: "link"
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/Justaguynamedpete",
    icon: "instagram",
    type: "link"
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/pete.mcgraw",
    icon: "facebook",
    type: "link"
  },
  {
    name: "Snapchat",
    url: "https://t.snapchat.com/SEGaDMLH",
    icon: "snapchat",
    type: "link"
  },
  {
    name: "Spotify",
    url: "https://open.spotify.com/artist/3vKt2mLH3Fkp0gZUYbwzFg",
    icon: "spotify",
    type: "link"
  },
  {
    name: "SoundCloud",
    url: "https://soundcloud.com/jest3rmusic",
    icon: "soundcloud",
    type: "link"
  },
  {
    name: "Venmo",
    url: "https://venmo.com/Peter_McGraw",
    icon: "venmo",
    type: "link"
  }
];
